<ng-container *ngIf="__ResultLiveData != undefined && __ResultLiveData.length > 0">
  <div class="liveAndStory">
    <story-slider
      [data]="liveMatchobservable | async | removeUniquePipe : 'SportNameOriginal' : 'SportName'"
      [elementData]="storySportsData"
      [filterItem]="_liveFilterItems"
      (clickedItem)="matchFilterBySport($event)"></story-slider>

    <!--    <mat-slide-toggle color="primary" class="settingsButton" (toggleChange)="onlyMatches()">{{'onlyMatches' | t}}</mat-slide-toggle>-->
  </div>
  <section class="selectPreventer">
    <div class="event-page-sports" id="eventpagesports">
      <h4>{{ 'home_live' | t }}</h4>
    </div>
    <mat-button-toggle-group id="eventpagesportsmattoogle" class="eventsHeader" (valueChange)="oddLiveMarketingChange($event)" value="{{ liveFilterSelectedSportId == 1 ? 9 : 0 }}">
      <mat-button-toggle value="0">
        <span>{{ 'tipp' | t }}</span>
      </mat-button-toggle>
      <mat-button-toggle value="8">
        <span>{{ 'NT' | t }}</span>
      </mat-button-toggle>
      <mat-button-toggle value="9">
        <span>RoM</span>
      </mat-button-toggle>
      <mat-button-toggle value="10">
        <span>{{ 'O/U' | t }}</span>
      </mat-button-toggle>
      <mat-button-toggle value="11">
        <span>1x2 HT</span>
      </mat-button-toggle>
      <mat-button-toggle value="12">
        <span>{{ 'NT' | t }} HT</span>
      </mat-button-toggle>
      <mat-button-toggle value="13">
        <span>RoM HT</span>
      </mat-button-toggle>
      <mat-button-toggle value="14">
        <span>{{ 'Ü/U 1.HZ' | t }}</span>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <!--<livematch-component [isHeaderShow]="isHeaderShow" (favChanged)="favsChanged()" [oddLiveMarketingValue]="oddLiveMarketingValue" [isInitialized]="this.isInitialized" [_selectedOdds]="this._selectedOdds" [__ResultLiveData]="this.__ResultLiveFavsData" [isFavSection]=true></livematch-component>-->
    <!--<livematch-component [isHeaderShow]="isHeaderShow" (favChanged)="favsChanged()" [oddLiveMarketingValue]="oddLiveMarketingValue" [isInitialized]="this.isInitialized" [_selectedOdds]="this._selectedOdds" [__ResultLiveData]="this.__ResultLiveData" [isFavSection]=false></livematch-component>-->

    <livematch-component
      [liveHeight]="{ height: 'auto' }"
      [isHeaderShow]="isHeaderShow"
      (favChanged)="favsChanged()"
      [oddLiveMarketingValue]="oddLiveMarketingValue"
      [isInitialized]="this.isInitialized"
      [_selectedOdds]="this._selectedOdds"
      [__ResultLiveData]="this.fullmatch"
      [isFavSection]="false"
      tippbarstyle="tipp-bar-live"></livematch-component>
    <br />
    <button mat-raised-button style="width: 100%; height: 50%" (click)="this.morelive()">See More Live Events</button>
    <!--<mat-divider></mat-divider>-->
    <mat-divider></mat-divider>
  </section>
</ng-container>
